import {
  FEELING_CHANGE,
  FEELING_SUBMIT_ERROR,
  FEELING_SUBMIT_REQUESTING,
  FEELING_SUBMIT_SUCCESS,
  FEELING_PROGRESS_CHANGE,
  FEELING_GET_ONBOARDING_STATS_REQUESTING,
  FEELING_GET_ONBOARDING_STATS_SUCCESS,
  FEELING_GET_ONBOARDING_STATS_ERROR,
} from "./constants";

import { IFeelingReducer } from "./types";

const initialState: IFeelingReducer = {
  requesting: false,
  errors: {
    global: "",
    name: "",
    email: "",
    password: "",
  },
  onboardingFeedbackStats: {
    recruiting: 5,
    integration: 5,
    position: 5,
    training: 5,
    preparation: 5,
    briefing: 5,
    visualization: 5,
    debriefing: 5,
    capitalization: 5,
    teamCohesion: 5,
    motivation: 5,
    leadership: 5,
    confidence: 5,
    stress: 5,
    publicSpeaking: 5,
    numberOfFeedbacks: 1,
  },
  progress: 0,
  progressRatio: 1 / 5,
  confidence: 0,
  productivity: 0,
  stress: 0,
  publicSpeaking: 0,
  teamCohesion: 0,
};

const reducer = function actionReducer(
  state: IFeelingReducer = initialState,
  action,
): IFeelingReducer {
  switch (action.type) {
    case FEELING_GET_ONBOARDING_STATS_REQUESTING:
    case FEELING_SUBMIT_REQUESTING: {
      return {
        ...state,
        requesting: true,
      };
    }

    case FEELING_PROGRESS_CHANGE:
      return {
        ...state,
        progress: state.progress + action.payload,
      };

    case FEELING_SUBMIT_SUCCESS:
      return {
        ...initialState,
        onboardingFeedbackStats: state.onboardingFeedbackStats,
      };

    case FEELING_GET_ONBOARDING_STATS_SUCCESS:
      return {
        ...state,
        onboardingFeedbackStats: action.payload,
        requesting: false,
      };

    case FEELING_GET_ONBOARDING_STATS_ERROR:
    case FEELING_SUBMIT_ERROR:
      return {
        ...state,
        requesting: false,
      };

    case FEELING_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
